module.exports = __webpack_public_path__ + "img/phone.b57e984d.svg";